import SeasonalBanner from '../ui/SeasonalBanner';
import HeroSection from './sections/HeroSection';
import VideoLiveSection from './sections/VideoLiveSection';
import EventsSection from './sections/EventsSection';
import ReadingPlansSection from './sections/ReadingPlansSection';
import { LibrarySection, GivingSection, PrayerSection, PastoralRdvSection } from './sections/QuickLinks';
import InfosPccSection from './InfosPccSection';
import LocationSection from './sections/LocationSection';

/**
 * Registre des SECTIONS de l'accueil de l'app.
 *
 * Chaque section est un composant autonome (lit ses propres données). Ce
 * registre sert à DEUX endroits :
 *  - l'accueil par défaut (repli JSX) = les sections dans `DEFAULT_HOME_ORDER` ;
 *  - (sprint Accueil) le rendu de la page Puck `accueil` = un bloc « section »
 *    par clé, résolu ici vers le vrai composant.
 *
 * `label` = libellé affiché dans l'éditeur (placeholder du bloc-section).
 */
export const HOME_SECTIONS = {
  banner:         { label: 'Bannière saisonnière', Component: SeasonalBanner },
  hero:           { label: 'Carrousel héro',        Component: HeroSection },
  video:          { label: 'Vidéo & Direct',        Component: VideoLiveSection },
  events:         { label: 'Événements',            Component: EventsSection },
  'reading-plans':{ label: 'Plans de lecture',      Component: ReadingPlansSection },
  library:        { label: 'Librairie',             Component: LibrarySection },
  giving:         { label: 'Donner',                Component: GivingSection },
  prayer:         { label: 'Ligne de prière',       Component: PrayerSection },
  'pastoral-rdv': { label: 'Rendez-vous pastoral',  Component: PastoralRdvSection },
  'infos-pcc':    { label: 'Infos PCC',             Component: InfosPccSection },
  location:       { label: 'Nous trouver',          Component: LocationSection },
};

// Ordre de l'accueil par défaut (= l'accueil actuel, à l'identique).
export const DEFAULT_HOME_ORDER = [
  'banner', 'hero', 'video', 'events', 'reading-plans',
  'library', 'giving', 'prayer', 'pastoral-rdv', 'infos-pcc', 'location',
];
